define(
	'actions/ideas-lab',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes",
	"shared/crm",
	"shared/client"
	],
	function($,_,Backbone,React,AppDispatcher,Constants, CRM, Client){
		return Backbone.Model.extend({
			init: function(params) {
			},
			addAssets: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_IDEASLAB,
					data: params
				});
			},
			pull: function(onComplete, onFail) {
				$.get(Client.getAPIURL() + "/media", {"vendor": "buncee", "asset_type": "idea", "page_size": 25, "sort_by": "newest"}, {}, "json"
				).done(function (response) {
					if(response) {
						onComplete(response);
					} else {
						onFail();
					}
				})
				AppDispatcher.dispatch({
					actionType: Constants.FETCHED_IDEASLAB
				});
			},
			pullWithFilters: function(allCategoriesGuid, appLevel, keywords, favorites, onComplete, onFail) {
				var combinedKeywords = appLevel;
				combinedKeywords = combinedKeywords.join("+");
				if (combinedKeywords.length > 0 && keywords.length > 0) {
					combinedKeywords = combinedKeywords.concat("&&"+ keywords);
				} else if(combinedKeywords.length === 0){
					combinedKeywords += keywords.toString();
				}
				
				if (combinedKeywords.length === 0) {
					combinedKeywords = undefined;
				}
				$.ajax({
					url: Client.getAPIURL() + "/media",
					data: {
						"vendor": "buncee", 
						"asset_type": "idea", 
						"categories" : allCategoriesGuid,
						"keywords": combinedKeywords,
						"favorited" : favorites ? 1 : undefined,
						"page_size": 25,
						"sort_by": "newest",
					},
					type: 'GET',
					headers: window.appData.user ? {
						'Authorization': "Bearer " + window.appData.user.access_token,
					} : {},
				}).done(function (response) {
					if(response) {
						onComplete(response);
					} else {
						onFail();
					}
				});
				AppDispatcher.dispatch({
					actionType: Constants.FETCHED_IDEASLAB
				});
			},
			getBookmarked: function(onComplete) {
				if (window.appData.user) {
                    $.ajax({
                        url: window.appData.client.api_url + "/media/buncee/favorites",
                        type: 'GET',
                        headers: {
                            'Authorization': "Bearer " + window.appData.user.access_token,
                        },
					})
					.done(function (response) {
						onComplete(response);
					})
					.fail(function (response) {
						console.log(response);
					});
                }
			},
			updateBookmarked: function(assetGuid, onComplete) {
				if (window.appData.user) {
                    $.ajax({
                        url: window.appData.client.api_url + "/media/buncee/favorites/" + assetGuid,
                        type: 'POST',
                        headers: {
                            'Authorization': "Bearer " + window.appData.user.access_token,
                        },
					})
					.done(function (response) {
						onComplete(response.state);
					})
					.fail(function (response) {
						console.log(response);
					});
                }
			}
		});
	}
);
